import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import authReducer from './authReducer';

const reducers = {
  auth: authReducer
};

const persistConfig = {
  key: 'rrsb',
  stateReconciler: autoMergeLevel2,
  storage,
  whitelist: ['auth'],
  timeout: 0
};

const persistedReducer = persistReducer(persistConfig, combineReducers({ ...reducers }));
export default persistedReducer;
